/* STENCIL IMPORTS */
import { h } from "@stencil/core";
/* OTHER LIBRARIES IMPORTS */
/* CUSTOM IMPORTS */
import { ItemData } from "../components/_helpers/list-selector/list-selector-item/list-selector-item";

export const renderListItems = (
  itemsData: ItemData[]
): HTMLGxIdeListSelectorItemElement[] => {
  const listItemsArray: HTMLGxIdeListSelectorItemElement[] = [];
  itemsData.forEach(item => {
    const id = item.itemId;
    const value = item.itemValue;
    const icon = item.itemIcon;
    listItemsArray.push(
      <gx-ide-list-selector-item
        itemId={id}
        itemValue={value}
        icon={icon}
        key={id}
      ></gx-ide-list-selector-item>
    );
  });
  return listItemsArray;
};
